exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page[data-v-7a3f4354]{\r\n    background-color: #2C61D5;\r\n    color: #fff;\n}\n.navbar-container[data-v-7a3f4354]{\r\n    background-color: #fff;\n}\n.content > img[data-v-7a3f4354] {\r\n    max-width: 110px;\r\n    margin-bottom: 48px;\r\n    opacity: 0.1;\n}\n.content[data-v-7a3f4354] {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 788px;\r\n    margin: 0 auto;\r\n    box-sizing: border-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    padding: 102px 10% 30px;\r\n    text-align: center;\n}\n.content > h1[data-v-7a3f4354] {\r\n    font-weight: 700;\r\n    font-size: 44px;\r\n    color: inherit;\n}\n.content > p[data-v-7a3f4354] {\r\n    font-weight: 700;\r\n    font-size: 22px;\r\n    line-height: 28px;\r\n    margin: 0;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7a3f4354","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/401.vue
// module id = 634
// module chunks = 0